export default __webpack_public_path__ + "static/media/evote.34f418cd.jpg";